import { cn } from '@/true-fsd/shared/utils/css'

/**
 * Пропсы для иконки выключенной подложки
 */
export interface BackgroundOffIconProps {
    /**
     * Дополнительные CSS классы
     */
    className?: string
}

/**
 * Иконка выключенной подложки (буква A без фона)
 */
export function BackgroundOffIcon({ className }: BackgroundOffIconProps) {
    return (
        <svg
            width="9"
            height="10"
            viewBox="0 0 9 10"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={cn(className)}
            aria-hidden="true"
            preserveAspectRatio="xMidYMid meet"
        >
            <path
                d="M0.737 9.373C0.529 9.373 0.36 9.32533 0.23 9.23C0.108667 9.13467 0.035 9.009 0.009 8.853C-0.017 8.68833 0.0133333 8.50633 0.1 8.307L3.532 0.702C3.64467 0.450667 3.779 0.273 3.935 0.169C4.09967 0.0563334 4.286 0 4.494 0C4.69333 0 4.871 0.0563334 5.027 0.169C5.19167 0.273 5.33033 0.450667 5.443 0.702L8.888 8.307C8.98333 8.50633 9.018 8.68833 8.992 8.853C8.966 9.01767 8.89233 9.14767 8.771 9.243C8.64967 9.32967 8.48933 9.373 8.29 9.373C8.04733 9.373 7.85667 9.31667 7.718 9.204C7.588 9.08267 7.471 8.90067 7.367 8.658L6.522 6.695L7.224 7.15H1.738L2.44 6.695L1.608 8.658C1.49533 8.90933 1.37833 9.09133 1.257 9.204C1.13567 9.31667 0.962333 9.373 0.737 9.373ZM4.468 1.911L2.648 6.24L2.31 5.824H6.652L6.327 6.24L4.494 1.911H4.468Z"
                fill="#94A6AF"
            />
        </svg>
    )
}

